import APIService from '@/services/APIService';

export default {
  historico() {
    return APIService.apiCall().get('/relatoriosAie/historico');
  },

  coordenadores() {
    return APIService.apiCall().get('/relatoriosAie/coordenadores');
  },

  adicionar(coordenador, peps = [], tipo = 'AIE') {
    const payload = peps.length ? { coordenador, peps } : { coordenador };
    if (tipo !== 'AIE') payload.tipo = tipo;
    return APIService.apiCall().post('/relatoriosAie/adicionar', JSON.stringify(payload));
  },

  baixar(id) {
    return APIService.apiCall().get(`/relatoriosAie/baixar/${id}`, {
      responseType: 'blob',
      timeout: 10 * 60 * 1000
    });
  }
};
